import { useLocation } from "react-router-dom";

export interface ChatContext {
  type: "appointment" | "indigo_doc";
  id: string;
  label: string;
}

export function useChatbotContext(): ChatContext | null {
  const { pathname } = useLocation();
  const apptMatch = pathname.match(/^\/appointments\/([\w-]+)/);
  if (apptMatch) {
    return { type: "appointment", id: apptMatch[1], label: "Appointment" };
  }
  const docMatch = pathname.match(/^\/docs\/([\w-]+)\/?$/);
  if (docMatch && docMatch[1] !== "report_prototype") {
    return { type: "indigo_doc", id: docMatch[1], label: "Indigo Doc" };
  }
  return null;
}
